import { BaseModel } from '../../_base/crud';

export class FacilityModel extends BaseModel {
  id: number;
  facility_id: string;
  facility_code: string;
  name: string;
  address_1: string;
  address_2: string;
  city: string;
  state: string;
  zip: string;
  location_id: number;
  phone: string;
  fax: string;
  email: string;
  npi: number;
  note: string;
  facility_type: string;
  days_supply: number;
  packing_id: number;
  filled_up_to: string;
  filled_by_robot: boolean;
  cycle_fill: boolean;
  lead_days: number;
  lead_days_to_bill: number;
  lead_days_to_delivery: number;
  processed: boolean;
  urbanization: any;
  is_active: boolean;
  last_modified_user: any;
  tags: any;
  entity_contacts: any;
  plus_code: any;
  latitude: any;
  longitude: any;
  geolocation_address;
  avatar;
  pre_signed_url;
  office_number: any;
  extension: any;
  clear() {
    this.urbanization = null;
    this.id = 0;
    this.name = '';
    this.facility_id = '';
    this.facility_code = '';
    this.name = '';
    this.address_1 = '';
    this.address_2 = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.location_id = 0;
    this.phone = '';
    this.fax = '';
    this.email = '';
    this.npi = 0;
    this.note = '';
    this.facility_type = '';
    this.days_supply = 0;
    this.packing_id = 0;
    this.filled_up_to = null;
    this.filled_by_robot = false;
    this.cycle_fill = false;
    this.lead_days = null;
    this.lead_days_to_bill = null;
    this.lead_days_to_delivery = null;
    this.processed = false;
    this.is_active = true;
    this.longitude = 0.0;
    this.latitude = 0.0;
    this.plus_code = 0.0;
    this.office_number = null;
    this.extension = null;
  }
}
